module.exports = __webpack_public_path__ + "static/img/nanny2.855735a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nanny2.png
// module id = XDwl
// module chunks = 14